import { PaperProps } from '@mui/material/Paper';
import { ListItemButton } from '@mui/material';
// locales
import { useLocales } from 'src/locales';
// components
import SvgColor from '../svg-color';

// ----------------------------------------------------------------------

interface Props extends PaperProps {
  query?: string;
}

export default function SearchNotFound({ query, sx, ...other }: Props) {
  const { t } = useLocales();

  return query ? (
    <ListItemButton
      sx={{
        p: 1.5,
        gap: 1,
        typography: 'subtitle2',
        opacity: 0.7,
        borderRadius: 1,
        pointerEvents: 'none'
      }}
    >
      <SvgColor
        src="/assets/icons/global/mynaui--chat.svg"
        sx={{ width: 18 }}
      />
      {t('not_found')}
    </ListItemButton>
  ) : (
    null
  );
}
